module.exports = __webpack_public_path__ + "img/all-bg1.62a88d77.jpg";